// Module
var code = "<script>let $ctrl</script> <div ng-include=\"$ctrl.getTemplate()\"></div> ";
// Exports
module.exports = code;